import { computed } from '@ember/object';
import CatalogObjectAdapter from '@square/dashboard-items-data/adapters/connect/catalog-object';
import { MULTIPLE_IMAGES_API_VERSION } from '@square/dashboard-items-data/adapters/connect/image';
export default CatalogObjectAdapter.extend({
  modelName: 'checkout-link',
  headers: computed(function () {
    return {
      'Square-Version': MULTIPLE_IMAGES_API_VERSION
    };
  }),
  findRecord(store, type, id) {
    return this._super(store, type, id, {
      adapterOptions: {
        includeRelatedObjects: true
      }
    });
  },
  query(store, type, options) {
    return this._super(store, type, options, {
      adapterOptions: {
        includeRelatedObjects: true
      }
    });
  }
});